import {Col, Form, Select} from 'antd';
// import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React from 'react';
// import {useSearchParams} from 'react-router-dom';

import {CommonErrors} from '../../constants/Common';
import {
  EFDBKey,
  EFDBLabel
} from '../../pages/configurator/dataManagement/utils/EFDatabase/constants/commonConstants';
// import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
// import {yearSelect} from '../../utils/FormUtils/yearSelect';

const EFDBForm: React.FC<{
  data?: any;
  currentStep?: number;
}> = ({currentStep}) => {
  // const yearFilter = yearSelect();
  // const [searchParam] = useSearchParams();
  // const [facilityOpt, setFacilityOpt] = useState([]);
  const {efdbJSON} = useJSONStore.getState();
  // const {getFieldValue} = useFormInstance();
  // const facilityDetails = useCompanyStore.getState().facilityDetails;

  // useEffect(() => {
  //   setFacilityOpt(
  //     facilityDetails?.[searchParam.get('selectedYear') ?? '']?.filter(
  //       (item: any) => {
  //         return !item.leased;
  //       }
  //     ) ?? []
  //   );
  // }, []);

  return (
    <>
      {/* <Col className="gutter-row" span={colSpan}> */}
      {currentStep === 0 && (
        <>
          {/* <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(yearKeyLabel.label)
                }
              ]}
              initialValue={searchParam.get('selectedYear')}
            >
              <Select placeholder={yearKeyLabel.label} options={yearFilter} />
            </Form.Item>
          </Col> */}
          {/* <Col>{`For ${getFieldValue(EFDBKey.facilityName)}`}</Col> */}
          {/* <Col className="gutter-row">
            <Form.Item
              name={facilityKeyLabel.key}
              label={facilityKeyLabel.label}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(facilityKeyLabel.label)
                }
              ]}
              initialValue={searchParam.get('facility')}
            >
              <Select
                placeholder={facilityKeyLabel.label}
                options={
                  facilityOpt?.map((item: any) => {
                    return {label: item.name, value: item._id};
                  }) ?? []
                }
              />
            </Form.Item>
          </Col> */}
          <Col className="gutter-row">
            <Form.Item
              name={EFDBKey.scope1}
              label={EFDBLabel.scope1}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(EFDBLabel.scope1)
                }
              ]}
            >
              <Select
                placeholder={EFDBLabel.scope1}
                options={efdbJSON.filter((item) => {
                  return item.scope.includes(1);
                })}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={EFDBKey.scope2}
              label={EFDBLabel.scope2}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(EFDBLabel.scope2)
                }
              ]}
            >
              <Select
                placeholder={EFDBLabel.scope2}
                options={efdbJSON.filter((item) => {
                  return item.scope.includes(2);
                })}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={EFDBKey.scope3}
              label={EFDBLabel.scope3}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(EFDBLabel.scope3)
                }
              ]}
            >
              <Select
                placeholder={EFDBLabel.scope3}
                options={efdbJSON
                  .filter((item) => {
                    return item.scope.includes(3);
                  })
                  .map((i) => {
                    return {...i, label: `${i.label} / EEIO`};
                  })}
              />
            </Form.Item>
          </Col>
        </>
      )}
      {/* {currentStep === 1 && <></>} */}
    </>
  );
};

export default EFDBForm;
